import React from 'react';

import useStyles from './styles';

const NumberIcon = ({ number }) => {
  const classes = useStyles();

  return <div className={classes.numberIcon}>+{number}</div>;
};

export default NumberIcon;
